<template>
  <v-main>
    <v-container fluid>
      <Slogen class="authWrap" />
      <v-row class="justify-center">
        <v-col xs="12" sm="6" md="4" lg="3">
          <v-card elevation="4" class="">
            <v-tabs centered background-color="blue" dark>
              <v-tab href="#login"> Sign-In </v-tab>
              <v-tab href="#register"> Register </v-tab>
              <v-tab-item value="login" class="pa-3"> <Login /> </v-tab-item>
              <v-tab-item value="register" class="pa-3 text-center">
                <p class="text-body-1">
                  Pine&sup3; Registration is currently limited <br />
                  Contact us for more details
                </p>
                <Register />
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script lang="ts">
import Vue from "vue";
import Login from "../components/Login.vue";
import Register from "@/components/Register.vue";
import Slogen from "@/components/Slogen.vue";

export default Vue.extend({
  components: { Login, Register, Slogen },
  name: "AuthView",
});
</script>
<style scoped>
.authWrap {
  margin-top: 20vh;
}
</style>
